import { useEffect } from 'react';

export const useBodyScrollBlock = () =>
    useEffect(() => {
        window.document.body.style.setProperty('overflow', 'hidden');

        return () => {
            window.document.body.style.removeProperty('overflow');
        };
    }, []);
